import type { Config } from "@hsl/core/fund-page/schemas";

export const config: Partial<Config> = {
    id: 0,
    fundCentreId: [],
    audienceId: 0,
    jurisdictionId: 0,
    usertypeId: 0,
    languageId: 0,
    fundId: 0,
    routeId: 0,
    url: "/srp/api/fund-centre",
    base_url: window.location.origin ?? "https://fundcentres.lgim.com",
    pageSections: [],
};

export default config;
